export default {
  laya: 'The digital learning platform for inclusive learning',
  imprint: 'Imprint',
  privacy: 'Privacy'
}
